export const GET_TEAMS = "GET_TEAMS";
export const ADD_TEAM = "ADD_TEAM";
export const EDIT_TEAM = "EDIT_TEAM";
export const GET_TEAM = "GET_TEAM";
export const RESET_TEAM = "RESET_TEAM";
export const ERROR_TEAM = "ERROR_TEAM";
export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
